<template>
  <div style="margin-top:20px">
    <el-form
      ref="form"
      label-width="80px"
      :model="form"
    >
      <el-form-item
        label="标题"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.title"
          :disabled="true"
        />
      </el-form-item>
      <el-form-item
        label="内容"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.content"
          type="textarea"
          :rows="3"
          :disabled="true"
        />
      </el-form-item>
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item
              label="类型"
              style="margin-right:15px"
            >
              <el-select
                v-model="form.type"
                :disabled="true"
              >
                <el-option
                  v-for="(v,k) in dicts.siteDeploy"
                  :key="k"
                  :label="v"
                  :value="k"
                />
              </el-select>
            </el-form-item>
          </div>
        </el-col>
        <el-col v-if="form.type=='PTYS' || form.status=='1'" :span="24">
          <div class="grid-content bg-purple">
            <el-form-item
              label="序号"
              prop="idx"
              style="margin-right:15px"
            >
              <el-input
                v-model="form.idx"
                :disabled="true"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item
              label="是否导航"
              prop="status"
              style="margin-right:15px"
            >
              <el-select
                v-model="form.status"
                clearable
                placeholder="请选择"
                :disabled="true"
              >
              <el-option value="0" label="否"></el-option>
              <el-option value="1" label="是"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-col>
        <el-col
          v-if="form.status=='1'"
          :span="12"
        >
          <div class="grid-content bg-purple">
            <el-form-item
              label="内路链接"
              prop="links"
              style="margin-right:15px"
            >
              <el-input
                v-model="form.links"
                placeholder="请输入"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="20" v-if="form.status=='1'">
          <div class="grid-content bg-purple">
            <el-form-item
              label="上级目录"
              prop="parentCode"
              style="margin-right:15px"
            >
             <el-cascader :options="options"
             v-model="form.parentCode"
             :emitPath="false"
             :props="{ checkStrictly: true }"
             :disabled="true"
             ></el-cascader>

            </el-form-item>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item
              label="图片"
              style="margin-right:15px"
            >
              <ImgUpload
                :upload-config="{ lebal: '门户图片', prefix: 'img', form, suffix: '', modal: false }"
                :parent-data="{ isDetail: true }"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="24"   v-if="form.type=='PTYS' || form.status=='1'">
          <div class="grid-content bg-purple">
            <el-form-item
              label="图片"
              style="margin-right:15px"
              :required="false"
            >
              <ImgUpload
                :upload-config="{ lebal: '导航图标图片', prefix: 'url', form, suffix: '', modal: false }"
                :parent-data="{ isDetail: false }"
                :required= "false"
              />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
  import request from '@/utils/request'
  import ImgUpload from "@/components/ImgUpload";
  
  export default {
    name: 'SiteDeployDetail',
    components: {
      ImgUpload
    },
    data() {
      return {
        options:[],
        emptyForm: {},
        dicts: { siteDeploy: {}},
        form: {
          code: '',
          branchCode: '',
          links: '',
          parentCode: '0',
          title: '',
          content: '',
          idx:'',
          img: '',
          type: '',
          url: '',
          status: ''
        }
      }
    },
    created() {
      // 保存空表单对象
      this.emptyForm = JSON.parse(JSON.stringify(this.form))
    },
    methods: {
      // 获取页面信息
      getInfo(code, dicts,options) {
        this.dicts = dicts
        this.options = options
        // 查询到数据之前先展示空表单
        this.form = JSON.parse(JSON.stringify(this.emptyForm))
        request({ url: `/ntocc-basic-api/siteDeploy/${code}`, method: 'get' }).then(response => {
          this.form = response.data
          this.form.status =response.data.status+''

        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .dialog-footer {
    margin-top: 50px;
  }
</style>
